import React, { useEffect, useState } from 'react'
import {Link} from 'react-router-dom'

import Axios from 'axios'

import Loader from '../../../Loader/Loader'
import { getCountries } from '../../../../api/api_football'

function Countries() {

    const [countries, setCountries] = useState()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {

        async function fetchData() {
            setIsLoading(true)
            try {
                const data = await getCountries()
                setCountries(data)
            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)

        }
        fetchData()

    }, [])

    if (isLoading) return <Loader />

    return (
        <div className="container my-4">
            <div className="row">
                {countries?.map((country, index) => {
                    return (
                        <div className="col-6 col-lg-3" key={index}>
                            <div className="card card-body mb-2">
                                <div>
                                    <Link to={`/countries/${country.country}`}>
                                        <img src={country.flag} className="img-fluid rounded-circle" style={{maxWidth: "20px"}} />
                                        <span> {country.country} </span>
                                    </Link>
                                </div>
                            </div>
                            
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
export default Countries